module.exports = __webpack_public_path__ + "static/corporative-bold-d5ac802b2c6bc7847b42d3d77b622dbc.woff";